import React, { useContext } from 'react';
import { PolicyHolderType } from '../CommonTypes';
import FormInput from '../FormInput';
import { useNavigate } from 'react-router-dom';
import { FeatureState, RoutePaths } from '../../../Constants/Common';
import Selectable from '../Selectable';
import './PolicyHolderInfo.scss';
import { t } from 'i18next';
import { SiteContext } from '../../../context/SiteContext';

type PolicyHolderInfoProps = {
    policyHolder: PolicyHolderType;
};

const PolicyHolderInfo = ({
    policyHolder
}: PolicyHolderInfoProps): JSX.Element => {
    const navigate = useNavigate();
    const { features } = useContext(SiteContext);
    const { title, firstName, middleName, lastName, email } = policyHolder;

    const {
        addressLine1,
        addressLine2,
        townOrCity,
        region,
        country,
        postcode
    } = policyHolder.address;
    const { accountHolderName, accountNumber, sortCode } =
        policyHolder.bankDetail;

    const onAmendPersonalDetailsButtonClick = () => {
        navigate(RoutePaths.AmendPersonalDetails);
    };

    const onAmendAddressButtonClick = () => {
        navigate(RoutePaths.AmendAddressDetails, {
            state: policyHolder.address
        });
    };

    const onAmendBankDetailsButtonClick = () => {
        console.log(policyHolder.bankDetail);
    };

    const onAmendEmailButtonClick = () => {
        navigate(RoutePaths.AmendEmailAddress);
    };

    return (
        <FormInput
            id='policyholderinfo'
            label={t('policy_holder_details_label')}
            helpText={t('help_text.policy_holder_info')}>
            <Selectable
                id={`policyholderdetails`}
                onClicked={() => onAmendPersonalDetailsButtonClick()}
                selected={false}
                hasSelectableButton={true}
                buttonText={t('amend')}
                style={{
                    border: '1px solid #ced4da',
                    marginTop: '10px'
                }}>
                <b>{t('title')}: </b>
                <span>{title}</span>
                <br />
                <b>{t('first_name')}: </b>
                <span>{firstName}</span>
                <br />
                <b>{t('middle_name')}: </b>
                <span>{middleName}</span>
                <br />
                <b>{t('last_name')}: </b>
                <span>{lastName}</span>
            </Selectable>
            <Selectable
                id={`policyholderaddressdetails`}
                onClicked={() => onAmendAddressButtonClick()}
                selected={false}
                hasSelectableButton={true}
                buttonText={t('amend')}
                style={{
                    border: '1px solid #ced4da',
                    marginTop: '10px'
                }}>
                <b>{t('address')}</b>
                <br />
                <b>{t('line_1_label')}</b>
                <span>{addressLine1}</span>
                <br />
                <b>{t('line_2_label')}</b>
                <span>{addressLine2}</span>
                <br />
                <b>{t('towncity_label')}: </b>
                <span>{townOrCity}</span>
                <br />
                <b>{t('county_label')}: </b>
                <span>{region}</span>
                <br />
                <b>{t('postcode')}: </b>
                <span>{postcode}</span>
                <br />
                <b>{t('country')}: </b>
                <span>{country}</span>
            </Selectable>
            <Selectable
                id={`policyholderemail`}
                onClicked={() => onAmendEmailButtonClick()}
                selected={false}
                hasSelectableButton={true}
                buttonText={t('amend')}
                style={{
                    border: '1px solid #ced4da',
                    marginTop: '10px'
                }}>
                <div className='div-text-align'>
                    <b>{t('email_address_label')}: </b>
                    <span>{email}</span>
                </div>
            </Selectable>
            {features.BankAccount === FeatureState.On && (
                <Selectable
                    id={`policyholderbankdetails`}
                    onClicked={() => onAmendBankDetailsButtonClick()}
                    selected={false}
                    hasSelectableButton={true}
                    buttonText={t('amend')}
                    style={{
                        border: '1px solid #ced4da',
                        marginTop: '10px'
                    }}>
                    <b>{t('bank_details')}</b>
                    <br />
                    <b>{t('account_holder_name')}</b>
                    <span>{accountHolderName}</span>
                    <br />
                    <b>{t('account_number')}</b>
                    <span>{accountNumber}</span>
                    <br />
                    <b>{t('sort_code')} </b>
                    <span>{sortCode}</span>
                </Selectable>
            )}
        </FormInput>
    );
};

export default PolicyHolderInfo;
